import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "@/lib/i18n";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import MobileBottomBar from "@/components/site/MobileBottomBar";
import ScrollToTop from "@/components/site/ScrollToTop";
import StructuredData from "@/components/site/StructuredData";
import ChatWidget from "@/components/site/ChatWidget";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import ServiceAreas from "@/pages/ServiceAreas";
import AreaDetail from "@/pages/AreaDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <LangProvider>
      <div className="App min-h-screen flex flex-col bg-white text-slate-900">
        <BrowserRouter>
          <ScrollToTop />
          <StructuredData />
          <ChatWidget />
          <Header />
          <main className="flex-1 pb-24 md:pb-0">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/service-areas" element={<ServiceAreas />} />
              <Route path="/service-areas/:slug" element={<AreaDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <MobileBottomBar />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </LangProvider>
  );
}

export default App;
